import { createAsyncThunk } from "@reduxjs/toolkit";
import { postAsync, getAsync } from "../../../api/Api";
import { store } from "src/redux/store";
import { getTsAffiliatesClicks } from "../appSlice/AppApi";

import { MobileOtp, ValidateOtpInput } from "@/utils/enums";
import { SaveTsClicksInput, SaveTsFlightsInput, SaveTsClicksResponse, SaveTsFlightsResponse, ExtendTsClickTimerInput, ExtendTsClickTimerResponse, SendOtpResponse, ValidateOtpResponse, CheckTsEligibilityResponse, GetTsPaymentMethodResponse, UpdateGroupMailingConfirmationInput, UpdateGroupMailingConfirmationResponse } from "@/utils/types";
import { mockDataEnabled, getMockCheckTsEligibilityResponse, MOCK_GET_TS_PAYMENT_METHOD_RESPONSE } from "@/mockData/MockData";

export const sendOtpApi = createAsyncThunk<SendOtpResponse, MobileOtp>(
  "appSlice/sendOtpApi",
  async (input: MobileOtp) => {
    const data = {
      url: "/cmd/login/send-otp",
      body: input,
    };
    if (mockDataEnabled) {
      return true as unknown as SendOtpResponse;
    }
    const response = await postAsync(data);
    return response as SendOtpResponse;
  }
);

export const validateOtpApi = createAsyncThunk<
  ValidateOtpResponse,
  ValidateOtpInput
>("appSlice/validateOtpApi", async (input: ValidateOtpInput) => {
  const data = {
    url: "/cmd/login/validate-otp",
    body: input,
  };
  if (mockDataEnabled) {
    return true as unknown as ValidateOtpResponse;
  }
  const response = await postAsync(data);
  return response as ValidateOtpResponse;
});

// POST /cmd/clicks/save-ts-click
export const saveTsClicksApi = createAsyncThunk<SaveTsClicksResponse, SaveTsClicksInput>(
  "appSlice/saveTsClicksApi",
  async (input: SaveTsClicksInput) => {
    const data = {
      url: "/cmd/clicks/save-ts-click",
      body: input,
    };
    if (mockDataEnabled) {
      store.dispatch(getTsAffiliatesClicks());
      return {
        feAffiliateUrl: "",
        feClickId: "mock-save-ts-click-id",
        feClickEndDate: "",
        feCardClosingDate: "",
        returnCode: 0,
        returnMessage: "success",
      } as SaveTsClicksResponse;
    }
    const response = (await postAsync(data)) as SaveTsClicksResponse;
    store.dispatch(getTsAffiliatesClicks());
    const hasClickId = response.feClickId != null && String(response.feClickId).trim() !== "";
    if (response.returnCode === 1 && !hasClickId) {
      throw new Error(
        response.returnMessage?.trim() || "error saving click"
      );
    }
    return response;
  }
);
// POST /cmd/clicks/extend-ts-click-timer
export const extendTsClickTimerApi = createAsyncThunk<ExtendTsClickTimerResponse, ExtendTsClickTimerInput>(
  "appSlice/extendTsClickTimerApi",
  async (input: ExtendTsClickTimerInput) => {
    const data = {
      url: "/cmd/clicks/extend-ts-click-timer",
      body: input,
    };
    if (mockDataEnabled) {
      return {
        returnCode: 0,
        returnMessage: "Affiliates timers fetched successfully",
        affiliates: null,
        affiliatesTimers: null,
      } satisfies ExtendTsClickTimerResponse;
    }
    const response = (await postAsync(data)) as ExtendTsClickTimerResponse;
    if (response.returnCode === 1) {
      throw new Error(
        response.returnMessage?.trim() || "error extending click"
      );
    }
    return response;
  }
);

export const saveTsFlightsApi = createAsyncThunk<SaveTsFlightsResponse, SaveTsFlightsInput>(
  "appSlice/saveTsFlightsApi",
  async (input: SaveTsFlightsInput) => {
    const data = {
      url: "/cmd/flights/save-ts-flight",
      body: input,
    };
    if (mockDataEnabled) {
      return {
        returnCode: 0,
        returnMessage: "OK",
        feFlightSharedId: "mock-shared-id",
      } satisfies SaveTsFlightsResponse;
    }
    const response = await postAsync(data); // POST
    return response as SaveTsFlightsResponse;
  }
);

// check-ts-eligibility
export const checkTsEligibilityApi = createAsyncThunk<CheckTsEligibilityResponse, void>(
  "appSlice/checkTsEligibilityApi",
  async () => {
    const data = {
      url: "/qry/eligibility/check",
    };
    if (mockDataEnabled) {
      return getMockCheckTsEligibilityResponse();
    }
    const response = await getAsync(data);
    return response as CheckTsEligibilityResponse;
  }
);

//get-ts-payment-method
export const getTsPaymentMethodApi = createAsyncThunk<GetTsPaymentMethodResponse, void>(
  "appSlice/getTsPaymentMethodApi",
  async () => {
    const data = {
      url: "/qry/credit-guard/get-ts-payment-method",
    };
    if (mockDataEnabled) {
      return MOCK_GET_TS_PAYMENT_METHOD_RESPONSE;
    }
    const response = await getAsync(data);
    return response as GetTsPaymentMethodResponse;
  }
);

//updateGroupMailingConfirmation
export const updateGroupMailingConfirmationApi = createAsyncThunk<UpdateGroupMailingConfirmationResponse, UpdateGroupMailingConfirmationInput>(
  "appSlice/updateGroupMailingConfirmationApi",
  async (input: UpdateGroupMailingConfirmationInput) => {
    const data = {
      url: "/cmd/user/update-group-mailing-confirmation",
      body: input,
    };
    if (mockDataEnabled) {
      return true as unknown as UpdateGroupMailingConfirmationResponse;
    }
    const response = await postAsync(data);
    return response as UpdateGroupMailingConfirmationResponse;
  }
);